export default __webpack_public_path__ + "static/media/moniquenicassio.4cd228c6.jpg";